import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { getCertificateConfig,
// 模板配置—获取证明模板配置
saveBasicCertificateConfig,
// 模板配置—保存通用模板配置
saveOfficialCertificateConfig,
// 模板配置—保存官方文件配置
saveCertificateConfig // 模板配置—保存员工模板配置
} from 'api/payroll/prove-download';
import './staff-template/tem.scss';
import { viewUrlFn as _viewUrlFn } from 'api/org/per';
import staffSearch from '_c/staff-search';
import upload from '_c/uploadAvatar';
import rdiff from 'recursive-diff';
import Preview from './preview';
export default {
  components: {
    upload: upload,
    staffSearch: staffSearch,
    Preview: Preview
  },
  computed: _objectSpread({}, mapState({
    // 产品套餐 ----> '1'基础 '2'高级 '3'老用户
    product_package: function product_package(state) {
      return state.user.company_info.product_package;
    }
  })),
  data: function data() {
    return {
      activeName: 'currency',
      fileFormat: ['.png', '.jpg', '.jpeg'],
      // 上传限制
      form: {
        name: '',
        staff_name_en: '',
        staff_name_th: '',
        job: '',
        name_ceo: '',
        staff_name_en_ceo: '',
        staff_name_th_ceo: '',
        job_ceo: ''
      },
      currencyData: {
        company_logo: '',
        c_name_th: '',
        c_sign: '',
        address: '',
        address_en: ''
      },
      wCurrencyData: {},
      officialData: {
        trustee_sign: '',
        trustee_staff_id: ''
      },
      staffData: {
        is_apply: '',
        // 是否允许员工App申请
        c_name_en: '',
        // 企业名称英
        staff_formal: [],
        // 可申请员工各类型
        send_language: [],
        // 发送文件语言
        c_short_name_th: '',
        // 企业简称泰
        c_short_name_en: '',
        // 企业简称英
        th_language: '',
        // 泰语标识
        en_language: '',
        // 英语标识
        date_format: '',
        // 日期格式
        sign_staff_id: '',
        // 签字人员工ID
        c_mobile: '',
        // 企业电话
        c_site: '',
        // 企业官网
        sign: '',
        // 负责人电子签名
        mobile: '',
        // 联系电话
        email: '' // 联系邮箱
      },

      currencyRules: {
        c_name_th: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }] // 企业名称（泰）
      },

      officialRules: {
        trustee_staff_id: [{
          required: true,
          message: this.$t('1256'),
          trigger: ['blur', 'change']
        }]
      },
      staffRules: {
        is_apply: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        staff_formal: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        send_language: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        date_format: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'change'
        }],
        c_mobile: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }],
        sign_staff_id: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'change'
        }],
        email: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }],
        c_name_en: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: this.$t('1256'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init(statu) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCertificateConfig();
            case 2:
              res = _context.sent;
              if (res) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (statu === 'currency' || !statu) _this.handleData(_this.currencyData, res.data);
              if (statu === 'official' || !statu) {
                _this.trusteeStaff({
                  staff_id: res.data.trustee_staff_id
                });
                _this.handleData(_this.officialData, res.data);
              }
              if (statu === 'staff' || !statu) {
                _this.staffChange({
                  staff_id: res.data.sign_staff_id
                });
                _this.handleData(_this.staffData, res.data);
              }
              _this.wCurrencyData = JSON.parse(JSON.stringify(_this.currencyData));
              _this.$nextTick(function () {
                _this.sendLanguage();
                _this.handleApply();
              });
              _this.form = Object.assign({}, _this.form, _this.staffData, _this.currencyData, _this.officialData);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleData: function handleData(data, res) {
      var keys = Object.keys(data);
      keys.forEach(function (key) {
        data[key] = res[key] || data[key];
      });
    },
    handleApply: function handleApply() {
      this.staffRules.staff_formal[0].required = true;
      if (this.staffData.is_apply === '2') {
        if (this.$refs.staffFormal) this.$refs.staffFormal.clearValidate();
        this.staffRules.staff_formal[0].required = false;
      }
    },
    trusteeStaff: function trusteeStaff(val) {
      this.officialData.trustee_staff_id = val.staff_id;
      this.viewUrlFn({
        staff_id: val.staff_id
      }, 'trusteeStaff', 'job_ceo', 'name_ceo', 'staff_name_en_ceo', 'staff_name_th_ceo');
    },
    // 选人
    staffChange: function staffChange(val) {
      this.staffData.sign_staff_id = val.staff_id;
      this.viewUrlFn({
        staff_id: val.staff_id
      }, 'staffSearch', 'job', 'name', 'staff_name_en', 'staff_name_th');
    },
    viewUrlFn: function viewUrlFn(val, staff, job, name, staff_name_en, staff_name_th) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _res$data, _res$data2, _res$data3, _res$data4;
        var res, supervisorInfo;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _viewUrlFn(val);
            case 2:
              res = _context2.sent;
              _this2.form[job] = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.job_title_name;
              _this2.form[name] = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.staff_name;
              _this2.form[staff_name_en] = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.staff_name_en;
              _this2.form[staff_name_th] = (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.staff_name_th;
              supervisorInfo = {
                avatar_url: res.data.avatar_url,
                mobile: res.data.mobile,
                staff_code: res.data.staff_code,
                staff_id: res.data.staff_id,
                staff_name: res.data.staff_name,
                staff_name_en: res.data.staff_name_en,
                staff_name_secondary: res.data.staff_name_secondary,
                staff_name_th: res.data.staff_name_th
              };
              if (_this2.$refs[staff]) {
                _this2.$refs[staff].res = supervisorInfo;
                _this2.$refs[staff].supOptions = [supervisorInfo].filter(function (v) {
                  return v.staff_name;
                });
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleClick: function handleClick() {
      this.$refs.config.scrollTop = this.$refs[this.activeName + 'Form'].$el.offsetTop - 64;
    },
    handleScroll: function handleScroll() {
      var config = this.$refs.config.scrollTop;
      // 高级套餐和老用户显示
      if (this.$refs.officialForm) {
        var officialForm = this.$refs.officialForm.$el.offsetTop - 64; // 420
        var staffForm = this.$refs.staffForm.$el.offsetTop - 64; // 753
        if (config < officialForm) {
          this.activeName = 'currency';
        } else if (config >= staffForm) {
          this.activeName = 'staff';
        } else {
          this.activeName = 'official';
        }
      } else {
        var _staffForm = this.$refs.staffForm.$el.offsetTop - 64; // 753
        if (config < _staffForm) {
          this.activeName = 'currency';
        } else {
          this.activeName = 'staff';
        }
      }
    },
    saveCurrency: function saveCurrency() {
      var _this3 = this;
      // 保存通用配置
      this.$refs.currencyForm.validate(function (valid) {
        if (valid) {
          saveBasicCertificateConfig({
            c_name_th: _this3.currencyData.c_name_th,
            company_logo: _this3.currencyData.company_logo,
            c_sign: _this3.currencyData.c_sign
          }).then(function (res) {
            _this3.$message.success(res.message);
            _this3.init('currency');
          });
        }
      });
    },
    saveOfficial: function saveOfficial() {
      var _this4 = this;
      // 保存官方文件
      var diff = rdiff.getDiff(this.currencyData, this.wCurrencyData);
      if (diff.length) {
        this.$message.error(this.$t('certificate_module_6'));
        return;
      }
      this.$refs.officialForm && this.$refs.officialForm.validate(function (valid) {
        if (valid) {
          saveOfficialCertificateConfig(_this4.officialData).then(function (res) {
            _this4.$message.success(res.message);
            _this4.init('official');
          });
        }
      });
    },
    saveStaff: function saveStaff() {
      var _this5 = this;
      var diff = rdiff.getDiff(this.currencyData, this.wCurrencyData);
      if (diff.length) {
        this.$message.error(this.$t('certificate_module_6'));
        return;
      }
      this.$refs.staffForm.validate(function (valid) {
        if (valid) {
          saveCertificateConfig(_this5.staffData).then(function (res) {
            _this5.$message.success(res.message);
            _this5.init('staff');
          });
        }
      });
    },
    // 预览
    staffPreview: function staffPreview() {
      var _this6 = this;
      this.$refs.staffForm.validate(function (valid) {
        if (valid) {
          _this6.$refs.pre.visible = true;
        }
      });
    },
    sendLanguage: function sendLanguage() {
      this.staffRules.c_name_en[0].required = true;
      if (!this.staffData.send_language.includes('en')) {
        if (this.$refs.nameEn) this.$refs.nameEn.clearValidate();
        this.staffRules.c_name_en[0].required = false;
      }
    },
    handleClose: function handleClose(data, bindValue) {
      data[bindValue] = '';
    },
    uploadSuccess: function uploadSuccess(val, data, bindValue) {
      data[bindValue] = val ? val.object_url : '';
    }
  }
};